import React, { useCallback, useContext } from 'react';
import { Route, Navigate } from 'react-router-dom';
import { Routes as PageRoutes } from 'react-router-dom';
import Maintenance from 'pages/Maintenance';
import { UserAuthContext } from 'context/UserAuthContext';
import CameraList from 'pages/SdRecordViewer/CameraList';

const Routes: React.FC = () => {
  const userAuthContext = useContext(UserAuthContext);

  const getRootNavigate = useCallback(() => {
    if (userAuthContext?.has_auth_for_sd_record_viewer_service) {
      return <Navigate to={'/sd_record_viewer/camera_list'} />;
    }
    return null;
  }, [userAuthContext]);

  return (
    <PageRoutes>
      <Route path="/" element={getRootNavigate()} />
      <Route path="/sd_record_viewer/camera_list" element={<CameraList />} />
      <Route path="/maintenance" element={<Maintenance />} />
    </PageRoutes>
  );
};

export default Routes;
